import { SET_DEFAULT_REDUX_MENU, SET_TAX_CONFIG } from '../reduxType';

const initialState = {
  settings: {
    collapsedMenu: false,
  },
  tax: {
    data: {
      ppn: {
        id: null,
        tax_name: '',
        tax_rate: 0,
        use_dpp: false,
        calculation_dpp: '',
      },
      pph: {
        id: null,
        tax_name: '',
        tax_rate: 0,
        use_dpp: false,
        calculation_dpp: '',
      },
    },
    loading: false,
  },
};

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case SET_DEFAULT_REDUX_MENU:
      return {
        ...state,
        settings: {
          ...payload,
        },
      };
    case SET_TAX_CONFIG:
      return {
        ...state,
        tax: {
          ...payload,
        },
      };
    default:
      return state;
  }
};
